import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    selectCartItems,
    selectAddMoreItem,
    selectStation,
    selectAddMoreItemToggle,
    selectPageName,
    selectToggle
} from '../../redux/cart/cart.selector';
import { toggleAddMoreItems } from '../../redux/cart/cart.action'
import CartButtom from '../cart-button/cart-button.component';
import AddMoreItem from '../../components/add-more-Items/add-more-items.component'

import CartIcon from '../../assets/Cart.png';

import './cart.style.css';


const cart = ({ items, addmoreItems, station, addMoreToggle, toggle, page, postion }) => {

    if (page === 'Journey Details' || page === 'Station Details') {

        return (
            <div className={`cart-container ${postion === true ? 'enable' : ''}`} id="cart">
                <div className='cart-title' style={{}}>
                    <img src={CartIcon} className="cart-img" alt='carticon' />
                    <p className="cart-p">Your Cart</p>
                </div>
                <div className='cart-list'>
                    <div className='cart-entries'>
                        <div>
                            <table className="uk-width-1-1 cart-table" >
                                <tbody>
                                    {items &&
                                        items.map(item =>
                                        (<tr key={item.id} className="cart-tr">
                                            <td className="cart-food-type"><div className={item.food_type === '1' ? 'green' : 'red'} id=''></div></td>
                                            <td className="cart-food-name"><p className='food-name'>{item.item_name} <span id='food-count'></span></p></td>
                                            <td className="cart-food-button">
                                                <CartButtom item={item} />
                                            </td>
                                            <td className="cart-food-price"><p className="cart-right"><i className="cart-price">₹</i>{item.price * item.quantity}</p></td>
                                        </tr>))
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {

        return (
            <div className="cart-container" id="cart">
                <div className='cart-title' style={{}}>
                    <img src={CartIcon} className="cart-img" alt='carticon' />
                    <p className="cart-p">Your Cart</p>
                </div>
                <div className='cart-list'>
                    <div className='cart-entries'>
                        <div>

                            {items &&
                                items.map(function (item) {
                                    if (item.status === undefined || item.status === 1) {
                                        return (
                                            <table key={item.id} className="uk-width-1-1 cart-table" >
                                                <tbody>
                                                    <tr key={item.id} className="cart-tr">
                                                        <td className="cart-food-type"><div className={item.food_type === '1' ? 'green' : 'red'} id=''></div></td>
                                                        <td className="cart-food-name"><p className='food-name'>{item.item_name} <span id='food-count'></span></p></td>
                                                        <td className="cart-food-button">
                                                            <CartButtom item={item} key={item.id} />
                                                        </td>
                                                        <td className="cart-food-price"><p className="cart-right"><i className="cart-price">₹</i> {item.price * item.quantity}</p></td>
                                                    </tr>
                                                </tbody>
                                            </table>)
                                    } else {

                                        return (
                                            <table key={item.id} className="uk-width-1-1 cart-table" >
                                                <tbody>
                                                    <tr key={item.id} className="cart-tr">
                                                        <td className="cart-food-type"><div className={item.food_type === '1' ? 'green' : 'red'} id=''></div></td>
                                                        <td className="cart-food-name"><p className='food-name inactive-cart'>{item.item_name} <span id='food-count'></span></p></td>
                                                        <td className="cart-food-button"></td>
                                                        <td className="cart-food-price"></td>
                                                    </tr>
                                                    <tr className="cart-tr">
                                                        <td className="cart-food-type"></td>
                                                        <td className="cart-food-name">
                                                            <p style={{ width: "100%", color: "red", fontSize: "10px", fontStyle: "italic" }}>item sold out</p>
                                                        </td>
                                                        <td className="cart-food-button"></td>
                                                        <td className="cart-food-price"></td>

                                                    </tr>
                                                </tbody>
                                            </table>)
                                    }
                                })
                            }

                        </div>
                    </div>
                </div>

                <AddMoreItem addmoreItems={addmoreItems.active_menus} />

                {(station.length !== 0 && addmoreItems.active_menus.length > 0) &&
                    <button id='cart-more' style={{ padding: '0px 15px' }} onClick={() => toggle()}>
                        {addMoreToggle === false ? "Add more item(s)" : "Hide item(s)"}
                    </button>
                }
            </div>
        )
    }
}
const mapStateToProps = createStructuredSelector({
    items: selectCartItems,
    addmoreItems: selectAddMoreItem,
    station: selectStation,
    addMoreToggle: selectAddMoreItemToggle,
    page: selectPageName,
    postion: selectToggle,
})
const mapDispatchToProps = dispatch => ({
    toggle: () => dispatch(toggleAddMoreItems())
})

export default connect(mapStateToProps, mapDispatchToProps)(cart);